import { bindRequestLogic } from './utils'
import RoleTypes from '../actionTypes/role'
import { roleAPI } from '../api'
import { mapPermissions, mapRoleDetail } from '../mapping'

const getRoles = bindRequestLogic({
  clientFunc: roleAPI.getRoles,
  type: RoleTypes.GET_ROLES_REQUEST,
  successType: RoleTypes.GET_ROLES_SUCCESS,
  failType: RoleTypes.GET_ROLES_FAILED,
  isQueryParam: true
})

const addRole = bindRequestLogic({
  clientFunc: roleAPI.addRole,
  type: RoleTypes.ADD_ROLE_REQUEST,
  successType: RoleTypes.ADD_ROLE_SUCCESS,
  failType: RoleTypes.ADD_ROLE_FAILED
})

const getRoleDetail = bindRequestLogic({
  clientFunc: roleAPI.getRoleDetail,
  type: RoleTypes.GET_ROLE_DETAIL_REQUEST,
  successType: RoleTypes.GET_ROLE_DETAIL_SUCCESS,
  failType: RoleTypes.GET_ROLE_DETAIL_FAILED,
  modelName: 'role',
  mapResponse: mapRoleDetail
})

const deleteRole = bindRequestLogic({
  clientFunc: roleAPI.deleteRole,
  type: RoleTypes.DELETE_ROLE_REQUEST,
  successType: RoleTypes.DELETE_ROLE_SUCCESS,
  failType: RoleTypes.DELETE_ROLE_FAILED
})

const updateRole = bindRequestLogic({
  clientFunc: roleAPI.updateRole,
  type: RoleTypes.UPDATE_ROLE_REQUEST,
  successType: RoleTypes.UPDATE_ROLE_SUCCESS,
  failType: RoleTypes.UPDATE_ROLE_FAILED
})

const getGroups = bindRequestLogic({
  clientFunc: roleAPI.getGroups,
  type: RoleTypes.GET_GROUPS_REQUEST,
  successType: RoleTypes.GET_GROUPS_SUCCESS,
  failType: RoleTypes.GET_GROUPS_FAILED,
  isQueryParam: true
})

const getPermissions = bindRequestLogic({
  clientFunc: roleAPI.getPermissions,
  type: RoleTypes.GET_PERMISSIONS_REQUEST,
  successType: RoleTypes.GET_PERMISSIONS_SUCCESS,
  failType: RoleTypes.GET_PERMISSIONS_FAILED,
  isQueryParam: true,
  mapResponse: mapPermissions
})

const deleteMultipleRole = bindRequestLogic({
  clientFunc: roleAPI.deleteMultipleRole,
  type: RoleTypes.DELETE_MULTIPLE_ROLE_REQUEST,
  successType: RoleTypes.DELETE_MULTIPLE_ROLE_SUCCESS,
  failType: RoleTypes.DELETE_MULTIPLE_ROLE_FAILED
})

const addRoleTranslation = bindRequestLogic({
  clientFunc: roleAPI.addRoleTranslation,
  type: RoleTypes.ADD_ROLE_TRANSLATION_REQUEST,
  successType: RoleTypes.ADD_ROLE_TRANSLATION_SUCCESS,
  failType: RoleTypes.ADD_ROLE_TRANSLATION_FAILED
})

const updateRoleTranslation = bindRequestLogic({
  clientFunc: roleAPI.updateRoleTranslation,
  type: RoleTypes.UPDATE_ROLE_TRANSLATION_REQUEST,
  successType: RoleTypes.UPDATE_ROLE_TRANSLATION_SUCCESS,
  failType: RoleTypes.UPDATE_ROLE_TRANSLATION_FAILED
})

const deleteRoleTranslation = bindRequestLogic({
  clientFunc: roleAPI.deleteRoleTranslation,
  type: RoleTypes.DELETE_ROLE_TRANSLATION_REQUEST,
  successType: RoleTypes.DELETE_ROLE_TRANSLATION_SUCCESS,
  failType: RoleTypes.DELETE_ROLE_TRANSLATION_FAILED
})

const getSystemRoles = bindRequestLogic({
  clientFunc: roleAPI.getSystemRoles,
  type: RoleTypes.GET_SYSTEM_ROLES_REQUEST,
  successType: RoleTypes.GET_SYSTEM_ROLES_SUCCESS,
  failType: RoleTypes.GET_SYSTEM_ROLES_FAILED,
  isQueryParam: true
})

const getRolesByAdminPortal = bindRequestLogic({
  clientFunc: roleAPI.getRoles,
  type: RoleTypes.GET_ROLES_BY_ADMIN_PORTAL_REQUEST,
  successType: RoleTypes.GET_ROLES_BY_ADMIN_PORTAL_SUCCESS,
  failType: RoleTypes.GET_ROLES_BY_ADMIN_PORTAL_FAILED,
  isQueryParam: true
})

export default [
  getRoles,
  addRole,
  getRoleDetail,
  updateRole,
  deleteRole,
  getGroups,
  getPermissions,
  deleteMultipleRole,
  addRoleTranslation,
  updateRoleTranslation,
  deleteRoleTranslation,
  getSystemRoles,
  getRolesByAdminPortal
]
